import { Dayjs } from "dayjs";
import { CalendarItemMap } from "../Calendar/CalendarItemMap.ts";
import { SlotDayAndHourKey } from "../Calendar/SlotDayAndHourKey.ts";
import { BookedSlotGroup } from "./types.ts";
import {
  getTeacherSlotStats,
  TeacherSlotFilter,
} from "./getTeacherSlotStats.ts";

export type BookedSlotTotals = {
  classRoomCount: number;
  availableCount: number;
};

const emptyTotals: BookedSlotTotals = { classRoomCount: 0, availableCount: 0 };

function addTotals(a: BookedSlotTotals, b: BookedSlotTotals): BookedSlotTotals {
  return {
    classRoomCount: a.classRoomCount + b.classRoomCount,
    availableCount: a.availableCount + b.availableCount,
  };
}

function totalsOfGroup(
  group: BookedSlotGroup,
  teacherFilter?: TeacherSlotFilter,
): BookedSlotTotals {
  if (!teacherFilter)
    return {
      classRoomCount: group.classRooms.length,
      availableCount: group.availableTeacherIds.length,
    };

  const { assignedCount, isAvailable } = getTeacherSlotStats(
    group,
    teacherFilter,
  );
  return {
    classRoomCount: assignedCount,
    availableCount: isAvailable ? 1 : 0,
  };
}

export function sumBookedSlotGroups(
  groups: BookedSlotGroup[],
  teacherFilter?: TeacherSlotFilter,
): BookedSlotTotals {
  return groups
    .map((group) => totalsOfGroup(group, teacherFilter))
    .reduce(addTotals, emptyTotals);
}

export function countTotalsOfDay(
  items: CalendarItemMap<BookedSlotGroup>,
  day: Dayjs,
  teacherFilter?: TeacherSlotFilter,
): BookedSlotTotals {
  return sumBookedSlotGroups(
    items.getAllSlotOfADate(SlotDayAndHourKey.fromDate(day)),
    teacherFilter,
  );
}

export function countTotalsOfDays(
  items: CalendarItemMap<BookedSlotGroup>,
  days: Dayjs[],
  teacherFilter?: TeacherSlotFilter,
): BookedSlotTotals {
  return days
    .map((day) => countTotalsOfDay(items, day, teacherFilter))
    .reduce(addTotals, emptyTotals);
}
